import styled from 'styled-components';
import { colors } from '../colors';

interface modalFooterProps {
	paddingTop?: string;
	padding?: string;
}

const ModalFooter = styled.div<modalFooterProps>`
	padding: 14px 26px;
	display: flex;
	padding-bottom: 30px;
	padding: ${(props) => props.padding}!important;
	padding: ${({ padding }) => padding}!important;
	padding-top: ${({ paddingTop }) => paddingTop}!important;
	justify-content: center;
	background: ${colors.Grey100};
	align-items: center;

	button {
		font-family: 'RubikMedium' !important;
		font-size: 15px;
		line-height: 18px;
		border-radius: 6px;
		height: auto;
		width: 115px;
		height: 34px;
		+ button {
			margin-left: 15px;
		}
	}
`;

export default ModalFooter;
